import { h, Component, Fragment } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import Observer from "../../utils/observer";
import User from "../../../../services/user";
import { BETS_SEARCH_STATUSES, BETS_STATUS, OUTCOMES_STATUS } from "../../utils/ticket-statuses";
import { Cell, CustomTable, EmptyRecordsMessage, FiltersRow, HCell, HRow, Pagination, Panel, PanelRow, Row } from "../../utils/table-utils";
import { DateHelperFilter, PerPageFilter } from "../../utils/form-utils";
import TicketLogic from "../../utils/ticket-logic";
import CashoutService from "../../../../services/cashout";
import MoneyFormatter from "../../utils/money-formatter";
import OddsFormatter from "../../utils/odds-formatter";

import * as U from "../../desktop-templates/menu-user";
import * as I from "../../utils/icons";
import * as C from "../../desktop-templates/cashout.jsx";
import { AutocashoutLabel, CompactCashoutButton, CondensedCashoutButton, ExtendedCashoutButton, Outcome, StatusBadge, TicketElement } from "../cashout";
import { CashoutOptionsContent } from "../../desktop-components/autocashout-tooltip";
import PageDataFeed from "../../../../services/page-data-feed";
import Ticket from "../../../../services/ticket";
import Config from "../../config.jsx";

export default class BetsHistoryPage extends Component {
    state = {
        dateFilter: {
            helperValue: 0,
            dateStartValue: '',
            dateEndValue: ''
        },
        perPage: 15,
        page: 1,
        lowlimit: 0,
        response: {},
        statusfilter: 'T',
        statustypes: {}
    };

    componentWillMount() {
        this.state.dateFilter.helperValue = this.props.defaultHelperValue ?? 1;
        this.state.dateFilter.dateStartValue = new Date().toLocaleDateString('en-CA');
        this.state.dateFilter.dateEndValue = this.state.dateFilter.dateStartValue;
        this.state.statustypes = BETS_SEARCH_STATUSES();
        this.performSearch();

        //> Se qualche ticket effettua cashout lancia un evento che possiamo ascoltare e tramite cui possiamo
        //> ricaricare i dati visualizzati per mostrare l'esito del cashout all'utente
        Observer.subscribe('ticket-cashout-done', this.performSearch.bind(this));
    }

    componentWillUnmount() {
        Observer.unsubscribe('ticket-cashout-done', this.performSearch.bind(this));
    }

    performSearch() {
        //(lowlimit, searchStatus, recordPerPage, searchHelper, startDate = null, endDate = null)
        User.fetchBets(
            this.state.lowlimit,
            this.state.statusfilter,
            this.state.perPage,
            this.state.dateFilter.helperValue,
            this.state.dateFilter.dateStartValue,
            this.state.dateFilter.dateEndValue,
        )
            .then(
                response => this.setState({
                    showbetrows: [],
                    response: {
                        totalrecords: response.totalrecords,
                        recordperpage: response.recordperpage,
                        page: this.state.page,
                        lowlimit: (this.state.page * response.recordperpage) - response.recordperpage,
                        data: response.bets.map(b => {
                            if (b.data_cashout == null) {
                                b.status = BETS_STATUS(b.statusCode);
                            } else {
                                b.status = window.Translation(msg`Cashout Win`);
                            }
                            return b;
                        })
                    }
                })
            );
    }

    changePage(newpage, newlowlimit) {
        //> Controllo di sicurezza per non fare richieste inutili
        if (!!Object.values(this.state.response)) {
            //> Esco se newpage è inferiore a 1 o maggiore del numero massimo di pagine possibili
            if (
                newpage < 1
                || newpage === this.state.page
                || newpage > Math.ceil(this.state.response.totalrecords / this.state.perPage)) {
                return;
            }
        }

        this.state.page = newpage;
        this.state.lowlimit = newlowlimit;
        this.performSearch();
    }

    changeFilter(filtertype) {
        this.state.page = 1;
        this.state.lowlimit = 0;
        this.state.statusfilter = filtertype;
        this.performSearch();
    }

    render() {
        return <div>
            <div class="overflow-x-auto user-menu-subnav">
                <U.SubTabsContainer>
                    {Object.entries(this.state.statustypes).map(
                        ([key, item]) => <U.Tab selected={key === this.state.statusfilter} onClick={e => this.changeFilter(key)} >{item.label}</U.Tab>
                    )}
                </U.SubTabsContainer>
            </div>
            <div class="user-menu-header main-text-color px-2 py-1 text-base font-bold ml-3 mt-2 capitalize rounded">{this.state.statustypes[this.state.statusfilter].description}</div>
            <FiltersRow class="gap-2 p-2 text-sm grid grid-cols-2">
                <DateHelperFilter
                    firstChild="col-span-2"
                    {...this.state.dateFilter}
                    onInput={(dateFilter) => {
                        this.state.dateFilter = dateFilter;
                        this.setState(this.state);
                    }}
                />
                <PerPageFilter
                    perPage={this.state.perPage}
                    pageList={[15, 30, 45, 50, 100]}
                    onInput={({ perPage }) => {
                        this.state.perPage = perPage;
                        this.setState(this.state);
                    }}
                />
                <div class="pt-4">
                    <a class="px-4 py-2 w-full flex items-center justify-center gap-2 bg-kobaaccent-400 text-black rounded" onClick={e => this.performSearch()}>
                        <Trans>Avvia Ricerca</Trans> <I.SearchIcon class="h-3 inline-block" />
                    </a>
                </div>
            </FiltersRow>
            <div class="text-sm mt-3">
                <BetsTable
                    {...this.state.response}
                    onIdClick={ticket => TicketLogic.printTicket(ticket)}
                    onNavigation={this.changePage.bind(this)}
                />
            </div>
        </div>;
    }
}

export class BetsTable extends Component {
    state = {
        totalpages: 0,
        totalrecords: 0,
        recordperpage: 0,
        page: 0,
        lowlimit: 0,
        data: [],
        onNavigation: false
    };

    componentWillMount() {
        this.updateLocalState(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.updateLocalState(nextProps);
    }

    updateLocalState(props) {
        this.state = props;
        this.state.totalpages = 0;

        if (!!this.state.totalrecords && !!this.state.recordperpage) {
            this.state.totalpages = Math.ceil(this.state.totalrecords / this.state.recordperpage);
        }

        this.setState(this.state);
    }

    render({ data, onIdClick = null }) {
        return <div class="px-2 py-1">
            <div class="py-1 border-t border-[color:var(--main-color)]">
                {!this.state.data.length ?
                    <EmptyRecordsMessage />
                    : <Fragment>
                        {this.state.data.map(bet => <div class="shadow mb-1 rounded-lg">
                            <ExtendedTicketElement ticket={CashoutService.normalizeTicket(bet.raw)} onCashout={e => this.loadBets()} />
                        </div>)}
                        {!!this.state.onNavigation && <Pagination
                            pages={this.state.totalpages}
                            currentPage={this.state.page}
                            onNavigation={page => { this.state.onNavigation(page, page * this.state.recordperpage - this.state.recordperpage) }}
                            isLastPage={this.state.totalpages === this.state.page}
                        />}
                    </Fragment>}
            </div>
        </div>;
    }
}

export class ExtendedTicketElement extends TicketElement {
    render({ ticket, onCashout }, { closed, showCashoutOptions }) {
        return <div>
            <TicketHeader onClick={e => this.toggleOpen()}>
                <TicketBaseInfo>
                    <div class="flex items-center justify-between pr-2"><span>{ticket.id}</span> <span class="font-normal">{ticket.live ? <Trans>Live</Trans> : <Trans>Prematch</Trans>}</span></div>
                    <div class="flex items-center justify-between pr-2">
                        <div class="">ID: <span class="font-mono">{ticket.ticketId}</span></div>
                        <div class="inline-block" onClick={e => PageDataFeed.printTicket({ code: ticket.ticketId })}><I.PrinterIcon class="h-3" /></div>
                    </div>
                    <div>{new Date(ticket.date).toLocaleString(undefined, { day: "numeric", month: "numeric", year: "2-digit", hour: "numeric", minute: "numeric" })}</div>
                </TicketBaseInfo>
                <TicketMoneyInfo>
                    <div class="flex items-center justify-between">
                        <span><Trans>Stake</Trans></span>
                        <div class="text-right">{ticket.betAmount.toFixed(2)}</div>
                    </div>

                    <div class="flex items-center justify-between">
                        <span><Trans>Odds</Trans></span>
                        <div class="text-right">{ticket.totOdd.toFixed(2)}</div>
                    </div>

                    <div class="flex items-center justify-between">
                        {this.isPending(ticket)
                            ? <Fragment>
                                <span><Trans>Max Win</Trans></span>
                                <div class="text-right">{ticket.maxWinAmount.toFixed(2)}</div>
                            </Fragment>
                            : <Fragment>
                                <span><Trans>Win</Trans></span>
                                <div class="text-right">{ticket.winAmount.toFixed(2)}</div>
                            </Fragment>}
                    </div>
                </TicketMoneyInfo>
                <TicketStatus>
                    {this.isPending(ticket) ?
                        <div onClick={e => e.stopPropagation()} class="w-full h-full border border-kobaaccent-600 text-center flex flex-col items-stretch justify-center font-normal bg-kobaaccent-500 text-slate-950 rounded">
                            <CondensedCashoutButton
                                ticket={ticket}
                                cashoutTicketHandler={this.cashoutTicketHandler}
                                cashoutWinAmount={CashoutService.calculateCashoutWin(ticket)}
                                toggleCashoutOptions={this.toggleCashoutOptions}
                            />
                        </div>
                        : <div class="flex items-end justify-end h-full pl-2">
                            <StatusBadge ticket={ticket} />
                        </div>}
                </TicketStatus>
                <div class="absolute top-0 right-0">
                    <I.AngleDown class={"h-4 transition-transform " + (closed ? "rotate-180" : "")} />
                </div>
            </TicketHeader>
            {closed ? null : <C.TicketSelections>
                {ticket.odds.map(outcome => <Outcome outcome={outcome} currentOdds={CashoutService.getUpdatedOdd(outcome.id)} />)}
            </C.TicketSelections>}
            {/* Mostra il tooltip se showCashoutOptions è true */}
            {showCashoutOptions && <div class="bg-white">
                <CashoutOptionsContent
                    row={ticket}
                    ticket={ticket}
                    onClose={() => this.setState({ showCashoutOptions: false })}
                    onAutoCashout={onCashout}
                    onPartialCashout={onCashout}
                />
            </div>}
        </div >
    }
}

export function TicketHeader({ children, onClick }) {
    return <div class="border border-kobaaccent-700 bg-kobaaccent-400 text-slate-950 flex items-stretch relative text-xs font-semibold pl-0.5" onClick={onClick}>{children}</div>
}
export function TicketBaseInfo({ children }) {
    return <div class="w-1/2">{children}</div>
}
export function TicketMoneyInfo({ children }) {
    return <div class="w-1/4">{children}</div>
}
export function TicketStatus({ children }) {
    return <div class="w-1/4 pr-0.5 pl-2 py-0.5">{children}</div>
}